import { gql } from '@apollo/client';

export interface EsSyncTaskResult {
    taskId: string;
    estimatedOrderCount: number;
    description: string;
}

export interface SyncEsByTimeRangeResponse {
    syncEsByTimeRange: EsSyncTaskResult;
}

export interface SyncEsByTimeRangeVariables {
    input: {
        startTime: string; // ISO-8601
        endTime: string;
    };
}

export const SYNC_ES_BY_TIME_RANGE = gql`
    mutation SyncEsByTimeRange($input: SyncEsByTimeRangeInput!) {
        syncEsByTimeRange(input: $input) {
            taskId
            estimatedOrderCount
            description
        }
    }
`;
